import { getChToPxConversionFactor, documentIsAvailable } from '../utils';

// Evaluate once at the module level and reuse value. This should be good enough for all known usage.
const conversionFactor = documentIsAvailable ? getChToPxConversionFactor() : 1;

export default () => conversionFactor;
